import _ from "lodash";
import { graphql, compose } from "lib/apolloClient";

import withLoader from "UIComponents/GqlWithLoader";
import { familyMembersFromStudentsQuery } from "MessagingV2/modules/MessagingQuery";
import { getOrganizationId } from "modules/CommonSelectors";
import { PARENT } from "Constants/stringConstants";
import MemberList from "./MemberList";

const getStudentIdsFromPreviousFamilyMembers = prevUsers => {
  const families = _.filter(prevUsers, { type: PARENT });
  const children = _.map(families, "children");
  const uniqueChildrenIds = _.reduce(
    children,
    (acc, children) => _.union(acc, _.map(children, "id")),
    []
  );
  return uniqueChildrenIds;
};

const memoizedUsers = _.memoize(
  (familyMembersEdge, prevUsers) => {
    return _.filter(familyMembersEdge, ({ node }) => {
      return !_.find(prevUsers, { id: node.id });
    });
  },
  (familyMembersEdge, prevUsers) => {
    // Generate a unique cache key based on the contents of the arguments
    return JSON.stringify({
      familyMembersEdge: _.map(familyMembersEdge, edge => edge.node.id),
      prevUsers: _.map(prevUsers, user => user.id),
    });
  }
);

const MemberListWithQueryWrapper = compose(
  graphql(familyMembersFromStudentsQuery, {
    name: "familyMembersFromStudents",
    options: props => {
      const { prevUsers } = props;

      const studentIds = getStudentIdsFromPreviousFamilyMembers(prevUsers);
      return {
        fetchPolicy: "cache-and-network",
        variables: {
          organizationId: getOrganizationId(),
          portalType: "PLANNER",
          filter: {
            students: studentIds,
            familyStatus: "ROSTERED",
          },
        },
      };
    },
    props: ({ familyMembersFromStudents, ownProps }) => {
      const prevUsers = _.get(ownProps, "prevUsers", []);

      const node = _.get(familyMembersFromStudents, "node", {});
      const familyMembersEdge = _.get(node, "familyMembers.edges", []);

      const usersToAdd = memoizedUsers(familyMembersEdge, prevUsers);

      return {
        isData: !_.isEmpty(node),
        isLoading: _.includes(
          [1, 2],
          familyMembersFromStudents["networkStatus"]
        ),
        users: usersToAdd,
      };
    },
  }),
  withLoader
)(MemberList);

export default MemberListWithQueryWrapper;
